"use strict"
import { otherGetRequest, otherPostRequest } from "@/services/RequestService";

export const getDefaultValue = async (product_id) => {
  const base_route = `advance-purchase?product_id=${product_id}`
  const response = await otherGetRequest(base_route);
  return response;
}

export const updateDefaultAdvancedPurchase = async (request) => {
  const base_route = `advance-purchase/update`;
  const response = await otherPostRequest(base_route, request);
  return response;
}

export const getAdvancedPromotions = async (product_id) => {
  const base_route = `product-promotion?product_id=${product_id}`
  const response = await otherGetRequest(base_route);
  return response;
}

export const store = async (request) => {
  const base_route = `product-promotion/add`;
  const response = await otherPostRequest(base_route, request);
  return response;
}

export const update = async (request, id) => {
  const base_route = `product-promotion/update/${id}`;
  const response = await otherPostRequest(base_route, request);
  return response;
}

export const togglePromotionStatus = async (id, request) => {
  const base_route = `product-promotion/toggle-status/${id}`;
  const response = await otherPostRequest(base_route, request);
  return response;
}

export const getLogs = async (product_id) => {
  const base_route = `promotion-log?product_id=${product_id}`
  const response = await otherGetRequest(base_route);
  return response;
}
